import styled from 'styled-components';
import {
    SpacingLargeLeftRight,
    SpacingMediumTop,
    SpacingSmallBottom,
    BreakpointRange,
    WithBreakpointRange,
} from '@mews-commander/ui';
import { createHandler } from '@mews/std';
import { getToken, withBreakpointRange } from '@optimus-web/core';

const getWidthCoefficients = (wide: $TSFixMe) => ({
    largeSize: wide ? 6 : 3,
    middleSize: wide ? 8 : 4,
    smallSize: wide ? 12 : 6,
});

const getWidth = createHandler(
    {
        [BreakpointRange.LargeDesktop.name]: (wide: $TSFixMe) => getWidthCoefficients(wide).largeSize / 12,
        [BreakpointRange.Desktop.name]: (wide: $TSFixMe) => getWidthCoefficients(wide).middleSize / 12,
        [BreakpointRange.Tablet.name]: (wide: $TSFixMe) => getWidthCoefficients(wide).smallSize / 12,
        [BreakpointRange.Phone.name]: 1,
    },
    1
);

export const DashboardPadding = ({ children }: $TSFixMe) => (
    <SpacingMediumTop>
        <SpacingLargeLeftRight>{children}</SpacingLargeLeftRight>
        <SpacingSmallBottom />
    </SpacingMediumTop>
);

export const BorderedDashboardBoxElement = styled.div<WithBreakpointRange & { wide?: boolean }>`
    border-bottom: 1px solid ${getToken('borderStaticPrimary')};
    border-right: 1px solid ${getToken('borderStaticPrimary')};
    overflow: hidden;
    width: ${({ wide, breakpointRange }) => getWidth(breakpointRange?.name, wide) * 100}%;
`;
export const BorderedDashboardBox = withBreakpointRange(BorderedDashboardBoxElement);

const DashboardBox = ({ children, ...other }: $TSFixMe) => (
    <BorderedDashboardBox {...other}>
        <DashboardPadding>{children}</DashboardPadding>
    </BorderedDashboardBox>
);

export default DashboardBox;
